import type { CurriculumDimensionDominante, PlanSession } from '../types/coursePlan';
import {
  SESSION_ARCHETYPE_OPTIONS,
  defaultSessionConfig,
  type SessionArchetype,
  type SessionConfig,
} from '../types/sessionArchetypes';
import { curriculumDimensionName } from './hitoCurriculumUi';

export const ARCHETYPE_BADGE_CLASS =
  'border border-gray-200 bg-transparent text-gray-700 font-medium';

/** Arquetipo sugerido según la dimensión curricular dominante del hito. */
export function getSuggestedArchetype(
  dimensionDominante?: CurriculumDimensionDominante | null,
): SessionArchetype {
  switch (dimensionDominante) {
    case 'OA':
      return 'indagacion';
    case 'OAH':
      return 'destreza';
    case 'OAA':
      return 'taller';
    default:
      return 'destreza';
  }
}

/** Config persistida por el docente, o sugerida desde curriculumSlice. */
export function resolveSessionConfig(
  session: Pick<PlanSession, 'config' | 'curriculumSlice'>,
): SessionConfig {
  if (session.config) return session.config;
  return defaultSessionConfig(getSuggestedArchetype(session.curriculumSlice?.dimensionDominante));
}

export function archetypeLabel(config?: SessionConfig): string {
  const resolved = config ?? defaultSessionConfig('destreza');
  const option = SESSION_ARCHETYPE_OPTIONS.find((item) => item.id === resolved.archetype);
  let label = option?.label ?? 'Destreza';
  if (resolved.archetype === 'destreza') {
    label += resolved.variant === 'autonomo' ? ' · Autónoma' : ' · Guiada';
  }
  return label;
}

export function archetypeFormatLabel(config?: SessionConfig): string {
  return `Formato: ${archetypeLabel(config)}`;
}

export function shouldShowArchetypeBadge(session: {
  config?: SessionConfig;
  detail?: string;
  curriculumSlice?: PlanSession['curriculumSlice'];
}): boolean {
  return (
    Boolean(session.config) ||
    Boolean(session.detail?.trim()) ||
    Boolean(session.curriculumSlice)
  );
}

export function getArchetypeSuggestionHint(
  dimensionDominante?: CurriculumDimensionDominante | null,
): string | null {
  if (!dimensionDominante) return null;

  const dimensionName = curriculumDimensionName(dimensionDominante);
  const suggestedId = getSuggestedArchetype(dimensionDominante);
  const suggestedLabel =
    SESSION_ARCHETYPE_OPTIONS.find((option) => option.id === suggestedId)?.label ?? suggestedId;

  return `Para la dimensión ${dimensionName}, el formato sugerido es ${suggestedLabel}.`;
}
